/* Plumeria Luxe : liste de favoris, sans compte ni app.
   Les favoris (handles produits) sont gardés dans le navigateur (localStorage « plumeria-favoris »).
   - cœur sur chaque carte produit (ajouté ici, pour toutes les grilles, y compris celles chargées après coup) ;
   - bouton [data-luxe-fav] sur la fiche produit (bloc luxe-favori) ;
   - compteur [data-luxe-fav-count] dans l'en-tête ;
   - page /pages/favoris : [data-luxe-favoris] (section luxe-favoris), avec ajout au panier, retrait et partage
     (lien ?liste=handle1,handle2 : la personne qui l'ouvre voit la liste et peut l'enregistrer). */
(function () {
  'use strict';
  if (window.luxeFavorisPret) return;
  window.luxeFavorisPret = true;

  var KEY = 'plumeria-favoris';
  var HEART =
    '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false"><path d="M12 20.3s-7.6-4.6-7.6-10.2A4.3 4.3 0 0 1 12 7.4a4.3 4.3 0 0 1 7.6 2.7c0 5.6-7.6 10.2-7.6 10.2z" fill="var(--luxe-fav-fill, none)" stroke="currentColor" stroke-width="1.3" stroke-linejoin="round"/></svg>';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function read() {
    try {
      var list = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(list) ? list.filter(function (h) { return typeof h === 'string' && h; }) : [];
    } catch (e) {
      return [];
    }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    refresh();
  }
  function has(handle) { return read().indexOf(handle) !== -1; }
  function toggle(handle) {
    var list = read();
    var i = list.indexOf(handle);
    if (i === -1) list.unshift(handle); else list.splice(i, 1);
    write(list);
    return i === -1;
  }
  function handleFromUrl(href) {
    var m = /\/products\/([^/?#]+)/.exec(href || '');
    return m ? decodeURIComponent(m[1]) : '';
  }
  function money(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + '€';
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* --- Cœurs sur les cartes produits --- */
  function decorateCards(scope) {
    (scope || document).querySelectorAll('product-card').forEach(function (card) {
      if (card.querySelector('.luxe-fav-card')) return;
      var link = card.querySelector('a.product-card__link, a[href*="/products/"]');
      var handle = link && handleFromUrl(link.getAttribute('href'));
      if (!handle) return;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'luxe-fav-card';
      btn.setAttribute('data-luxe-fav', handle);
      btn.innerHTML = HEART;
      card.appendChild(btn);
    });
    refresh();
  }

  /* --- État de tous les boutons et du compteur --- */
  function refresh() {
    var list = read();
    document.querySelectorAll('[data-luxe-fav]').forEach(function (btn) {
      var on = list.indexOf(btn.getAttribute('data-luxe-fav')) !== -1;
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.setAttribute('aria-label', on ? 'Retirer de mes coups de cœur' : 'Ajouter à mes coups de cœur');
      var label = btn.querySelector('[data-luxe-fav-label]');
      var wanted = on ? 'Dans vos coups de cœur' : 'Ajouter à mes coups de cœur';
      if (label && label.textContent !== wanted) label.textContent = wanted;
    });
    document.querySelectorAll('[data-luxe-fav-count]').forEach(function (el) {
      /* Comparer avant d'écrire : sinon l'observateur de la page relancerait refresh() sans fin */
      var text = list.length ? String(list.length) : '';
      if (el.textContent !== text) el.textContent = text;
      if (el.hidden !== !list.length) el.hidden = !list.length;
    });
  }

  document.addEventListener(
    'click',
    function (event) {
      var btn = event.target.closest && event.target.closest('[data-luxe-fav]');
      if (!btn) return;
      event.preventDefault();
      event.stopPropagation();
      var added = toggle(btn.getAttribute('data-luxe-fav'));
      if (added) {
        btn.classList.remove('is-pop');
        void btn.offsetWidth;
        btn.classList.add('is-pop');
      }
    },
    true
  );
  window.addEventListener('storage', function (e) { if (e.key === KEY) { refresh(); renderPage(); } });

  /* --- Page « Mes favoris » --- */
  var cache = {};
  function fetchProduct(handle) {
    if (!cache[handle]) {
      cache[handle] = fetch(root + 'products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return cache[handle];
  }

  /* Pastille de couleur d'après le nom de la valeur (Argent, Or, Or rose, Noir…) */
  function swatch(value) {
    var v = String(value).toLowerCase();
    if (/rose/.test(v)) return 'linear-gradient(135deg, #f5d9cf, #c98e7d)';
    if (/\bor\b|dor|gold/.test(v)) return 'linear-gradient(135deg, #f7e7b4, #c9a14a)';
    if (/argent|silver|titane|acier/.test(v)) return 'linear-gradient(135deg, #f7f7f7, #a8a8a8)';
    if (/noir|black/.test(v)) return '#1d1d1d';
    if (/bleu|blue/.test(v)) return 'linear-gradient(135deg, #8fb3e6, #3b5ba5)';
    if (/arc|rainbow|multi/.test(v)) return 'conic-gradient(#e9b6c9, #b8a9e6, #8fd3e6, #b6e6a9, #f2dc9a, #e9b6c9)';
    return '#d8cfc1';
  }
  function isColor(name) { return /couleur|coloris|colou?r|finition/i.test(name); }

  var products = {};   /* handle -> produit (.js) */
  var choices = {};    /* handle -> valeurs choisies, une par option */

  function cardHtml(p, shared) {
    products[p.handle] = p;
    var available = p.variants.filter(function (v) { return v.available; });
    choices[p.handle] = p.options.map(function (o) { return o.values.length === 1 ? o.values[0] : null; });
    var options = '';
    p.options.forEach(function (o, i) {
      if (o.values.length < 2) return;
      var color = isColor(o.name);
      options +=
        '<div class="luxe-favs__option"><span class="luxe-favs__option-name">' + esc(o.name) + '</span><div class="luxe-favs__values">' +
        o.values.map(function (val) {
          return color
            ? '<button type="button" class="luxe-favs__swatch" data-opt="' + i + '" data-val="' + esc(val) + '" style="--sw: ' + swatch(val) + '" aria-label="' + esc(o.name + ' : ' + val) + '" title="' + esc(val) + '"></button>'
            : '<button type="button" class="luxe-favs__pill" data-opt="' + i + '" data-val="' + esc(val) + '">' + esc(val) + '</button>';
        }).join('') +
        '</div></div>';
    });
    var img = p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') === -1 ? '?' : '&') + 'width=600' : '';
    return (
      '<li class="luxe-favs__item" data-handle="' + esc(p.handle) + '">' +
      (shared ? '' : '<button type="button" class="luxe-favs__remove" data-luxe-favs-remove="' + esc(p.handle) + '" aria-label="Retirer ' + esc(p.title) + ' de mes favoris"><svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="1.3"/></svg></button>') +
      '<a class="luxe-favs__media" href="' + esc(p.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="' + esc(p.title) + '" loading="lazy" data-luxe-favs-img>' : '') + '</a>' +
      '<div class="luxe-favs__info"><span class="luxe-favs__material">Titane ASTM F136</span>' +
      '<a class="luxe-favs__name" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
      '<span class="luxe-favs__price" data-luxe-favs-price></span></div>' +
      options +
      (available.length
        ? '<button type="button" class="luxe-favs__add" data-luxe-favs-add=""></button>'
        : '<span class="luxe-favs__soldout">Bientôt de retour</span>') +
      '</li>'
    );
  }

  /* Variante correspondant aux choix (null tant qu'une option manque) */
  function chosenVariant(handle) {
    var p = products[handle], sel = choices[handle];
    if (!p || sel.indexOf(null) !== -1) return null;
    return p.variants.filter(function (v) {
      return v.options.every(function (val, i) { return val === sel[i]; });
    })[0] || null;
  }

  function updateItem(item) {
    var handle = item.getAttribute('data-handle');
    var p = products[handle], sel = choices[handle];
    if (!p) return;
    var variant = chosenVariant(handle);

    /* Valeurs possibles compte tenu des autres choix */
    item.querySelectorAll('[data-opt]').forEach(function (b) {
      var i = Number(b.getAttribute('data-opt')), val = b.getAttribute('data-val');
      var ok = p.variants.some(function (v) {
        return v.available && v.options[i] === val && v.options.every(function (x, j) { return j === i || sel[j] === null || sel[j] === x; });
      });
      b.classList.toggle('is-selected', sel[i] === val);
      b.classList.toggle('is-unavailable', !ok);
      b.setAttribute('aria-pressed', sel[i] === val ? 'true' : 'false');
    });

    var prices = p.variants.filter(function (v) { return v.available; }).map(function (v) { return v.price; });
    var priceEl = item.querySelector('[data-luxe-favs-price]');
    if (variant) priceEl.textContent = money(variant.price);
    else if (prices.length && Math.min.apply(null, prices) !== Math.max.apply(null, prices)) priceEl.textContent = 'À partir de ' + money(Math.min.apply(null, prices));
    else priceEl.textContent = money(prices.length ? prices[0] : p.price);

    /* Photo : celle de la variante choisie, ou à défaut d'une variante qui correspond aux choix déjà faits (ex. la couleur) */
    var pictured = variant && variant.featured_image ? variant : p.variants.filter(function (v) {
      return v.featured_image && v.options.every(function (x, i) { return sel[i] === null || sel[i] === x; });
    })[0];
    var img = item.querySelector('[data-luxe-favs-img]');
    if (img && pictured && sel.some(function (x, i) { return x !== null && p.options[i].values.length > 1; })) {
      var src = pictured.featured_image.src + (pictured.featured_image.src.indexOf('?') === -1 ? '?' : '&') + 'width=600';
      if (img.getAttribute('src') !== src) img.setAttribute('src', src);
    }

    var add = item.querySelector('[data-luxe-favs-add]');
    if (!add) return;
    if (add.dataset.busy) return;
    var missing = sel.indexOf(null);
    if (variant && variant.available) {
      add.setAttribute('data-luxe-favs-add', variant.id);
      add.disabled = false;
      add.textContent = 'Ajouter au panier';
    } else {
      add.setAttribute('data-luxe-favs-add', '');
      add.disabled = true;
      add.textContent = variant ? 'Indisponible' : 'Sélectionner ' + p.options[missing].name.toLowerCase();
    }
    item.classList.remove('is-missing');
  }

  function notifyCart(cart) {
    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: { resource: cart, sourceId: 'luxe-favoris', data: { source: 'luxe-favoris', itemCount: cart.item_count } }
    }));
  }
  function addToCart(ids) {
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: ids.map(function (id) { return { id: Number(id), quantity: 1 }; }) })
    })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }); })
      .then(function (r) { return r.json(); })
      .then(function (cart) { notifyCart(cart); return cart; });
  }

  function renderPage() {
    var page = document.querySelector('[data-luxe-favoris]');
    if (!page) return;
    var params = new URLSearchParams(location.search);
    var sharedParam = params.get('liste');
    var shared = sharedParam !== null;
    var handles = shared ? sharedParam.split(',').filter(Boolean).slice(0, 60) : read();
    var grid = page.querySelector('[data-luxe-favs-grid]');
    var empty = page.querySelector('[data-luxe-favs-empty]');
    var tools = page.querySelector('[data-luxe-favs-tools]');
    var sharedBar = page.querySelector('[data-luxe-favs-shared]');
    var count = page.querySelector('[data-luxe-favs-count]');
    var status = page.querySelector('[data-luxe-favs-status]');
    var setCount = function (n) { if (count) count.textContent = n ? n + (n > 1 ? ' bijoux' : ' bijou') : ''; };

    if (status) status.textContent = '';
    sharedBar.hidden = !shared;
    tools.hidden = !handles.length;
    tools.classList.toggle('is-shared', shared);
    empty.hidden = handles.length > 0;
    setCount(handles.length);
    if (!handles.length) { grid.innerHTML = ''; return; }

    Promise.all(handles.map(fetchProduct)).then(function (list) {
      var found = list.filter(Boolean);
      /* Un bijou retiré de la boutique disparaît aussi de la liste */
      if (!shared && found.length !== handles.length) {
        var keep = found.map(function (p) { return p.handle; });
        try { localStorage.setItem(KEY, JSON.stringify(read().filter(function (h) { return keep.indexOf(h) !== -1; }))); } catch (e) {}
        refresh();
      }
      grid.innerHTML = found.map(function (p) { return cardHtml(p, shared); }).join('');
      grid.querySelectorAll('.luxe-favs__item').forEach(updateItem);
      empty.hidden = found.length > 0;
      tools.hidden = !found.length;
      setCount(found.length);
    });
  }

  function initPage() {
    var page = document.querySelector('[data-luxe-favoris]');
    if (!page || page.dataset.ready) return;
    page.dataset.ready = '1';
    var status = page.querySelector('[data-luxe-favs-status]');

    page.addEventListener('click', function (event) {
      var value = event.target.closest('[data-opt]');
      if (value) {
        var item = value.closest('.luxe-favs__item');
        var sel = choices[item.getAttribute('data-handle')];
        var i = Number(value.getAttribute('data-opt'));
        sel[i] = sel[i] === value.getAttribute('data-val') ? null : value.getAttribute('data-val');
        /* Un choix devenu impossible avec la nouvelle valeur est effacé */
        var p = products[item.getAttribute('data-handle')];
        sel.forEach(function (val, j) {
          if (j === i || val === null || p.options[j].values.length === 1) return;
          var ok = p.variants.some(function (v) { return v.available && v.options.every(function (x, k) { return sel[k] === null || sel[k] === x; }); });
          if (!ok) sel[j] = null;
        });
        updateItem(item);
        return;
      }

      var remove = event.target.closest('[data-luxe-favs-remove]');
      if (remove) {
        write(read().filter(function (h) { return h !== remove.getAttribute('data-luxe-favs-remove'); }));
        renderPage();
        return;
      }

      var add = event.target.closest('[data-luxe-favs-add]');
      if (add && !add.disabled && add.getAttribute('data-luxe-favs-add')) {
        add.disabled = true;
        add.dataset.busy = '1';
        add.textContent = '…';
        addToCart([add.getAttribute('data-luxe-favs-add')])
          .then(function () {
            add.textContent = 'Ajouté au panier';
            setTimeout(function () { delete add.dataset.busy; updateItem(add.closest('.luxe-favs__item')); }, 2400);
          })
          .catch(function () { delete add.dataset.busy; add.disabled = false; add.textContent = 'Réessayer'; });
        return;
      }

      var addAll = event.target.closest('[data-luxe-favs-add-all]');
      if (addAll) {
        var ids = [], waiting = [];
        page.querySelectorAll('.luxe-favs__item').forEach(function (it) {
          if (!it.querySelector('[data-luxe-favs-add]')) return; /* épuisé */
          var v = chosenVariant(it.getAttribute('data-handle'));
          if (v && v.available) ids.push(v.id); else waiting.push(it);
        });
        waiting.forEach(function (it) { it.classList.remove('is-missing'); void it.offsetWidth; it.classList.add('is-missing'); });
        var wait = waiting.length
          ? (waiting.length > 1 ? waiting.length + ' bijoux attendent' : '1 bijou attend') + ' votre choix de couleur ou de taille.'
          : '';
        if (!ids.length) { status.textContent = wait || 'Aucun bijou disponible à ajouter.'; return; }
        status.textContent = '…';
        addToCart(ids)
          .then(function () {
            status.textContent = (ids.length > 1 ? ids.length + ' bijoux ajoutés' : '1 bijou ajouté') + ' au panier.' + (wait ? ' ' + wait : '');
          })
          .catch(function () { status.textContent = "L'ajout n'a pas abouti, merci de réessayer."; });
        return;
      }

      if (event.target.closest('[data-luxe-favs-clear]')) {
        if (window.confirm('Retirer tous les bijoux de vos coups de cœur ?')) { write([]); renderPage(); }
        return;
      }

      if (event.target.closest('[data-luxe-favs-save]')) {
        var mine = read();
        (new URLSearchParams(location.search).get('liste') || '').split(',').filter(Boolean).forEach(function (h) {
          if (mine.indexOf(h) === -1) mine.push(h);
        });
        write(mine);
        location.href = location.pathname;
        return;
      }

      var share = event.target.closest('[data-luxe-favs-share]');
      if (share) {
        var url = location.origin + location.pathname + '?liste=' + read().map(encodeURIComponent).join(',');
        var done = function () {
          status.textContent = 'Le lien de votre liste est copié : il ne reste qu’à le coller dans un message.';
        };
        if (navigator.share) {
          navigator.share({ title: 'Mes coups de cœur Plumeria', url: url }).catch(function () {});
        } else if (navigator.clipboard) {
          navigator.clipboard.writeText(url).then(done, function () { window.prompt('Copiez ce lien :', url); });
        } else {
          window.prompt('Copiez ce lien :', url);
        }
      }
    });

    renderPage();
  }

  function init() {
    decorateCards(document);
    initPage();
    /* Grilles chargées après coup (filtres, pages suivantes, recommandations, éditeur) */
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; decorateCards(document); initPage(); });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
